'use client';

interface CategoriesProps {
  dataCategory: string;
  setCategory: (category: string) => void;
}

const CATEGORIES_LIST = [
  { label: 'Axé', value: 'axe' },
  { label: 'Forró', value: 'forro' },
  { label: 'Vaqueijada', value: 'vaqueijada' },
  { label: 'Seresta', value: 'seresta' },
  { label: 'Soul', value: 'soul' },
  { label: 'Reggae', value: 'reggae' },
  { label: 'Lambada', value: 'lambada' },
  { label: 'Pisadinha', value: 'pisadinha' },
  { label: 'Bregão', value: 'brega' },
  { label: 'MPB', value: 'mpb' },
  { label: 'Jovem Guarda', value: 'jovemguarda' },
  { label: 'Sertanejo', value: 'sertanejo' },
  { label: 'Rock', value: 'rock' },
  { label: 'Samba', value: 'samba' },
  { label: 'Funk', value: 'funk' },
  { label: 'Gospel', value: 'gospel' },
];

const Categories: React.FC<CategoriesProps> = ({
  dataCategory,
  setCategory
}) => {
  return (
    <div className="flex flex-wrap gap-2 py-3">
      {CATEGORIES_LIST.map((item) => {
        const isSelected = dataCategory === item.value;

        return (
          <button
            key={item.value}
            type="button"
            onClick={() => setCategory(item.value)}
            className={`
              px-4 py-2 rounded-full text-xs font-medium transition-all duration-200 ease-in-out cursor-pointer
              ${
                isSelected
                  ? 'bg-neutral-900 text-white shadow-sm scale-105'
                  : 'bg-neutral-100 text-neutral-600 hover:bg-neutral-200 hover:text-neutral-900'
              }
            `}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
};

export default Categories;
